
import { DebugerAppRoutingModule } from './debuger-app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EditorModule } from '../editor/editor.module';
import { DebugLogService } from './services/debug-log.service';
import { TicketService } from './services/ticket.service';
import { SupportComponent } from './ticket-support/support.component';

@NgModule({
  imports: [
    CommonModule,
    DebugerAppRoutingModule,
    EditorModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [SupportComponent],
  exports: [SupportComponent],
  providers: [DebugLogService, TicketService]
})
export class DebugerAppModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/debuger-app/debuger-app.module.ts